<!--
 * @Description:  员工关系
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-01 11:03:36
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <!-- <v-row>
          <v-col cols="auto">
            <mrc_ess_switch v-model="list.correlation_status"
                            v-if="$store.state.uuid"
                            :true-value="1"
                            :false-value="0"
                            :readonly="disabled"
                            :true-text="$t('label_To_enable_the')"
                            :false-text="$t('label_disable')">
            </mrc_ess_switch>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col cols="12"
                 sm="6">
            <!-- 员工关系名称 -->
            <mrc_ess_multiText :label="$t('label_staff_correlation_name')"
                               noRequired
                               :error-messages="
                  $errors('list', 'correlation_name', requiredRule)
                  "
                               :isNational="judegNational('correlation_name')"
                               v-model="list.correlation_name"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12"
                 sm="6">
            <mrc_ess_multiText :label="$t('label_code')"
                               noRequired
                               :error-messages="
                  $errors('list', 'correlation_code', requiredRule)
                  "
                               :isNational="judegNational('correlation_code')"
                               v-model="list.correlation_code"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_describe')"
                               noRequired
                               :error-messages="
                  $errors('list', 'remarks', requiredRule)
                  "
                               :isNational="judegNational('remarks')"
                               v-model="list.remarks"
                               :readonly="disabled">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success="success"
                         @cancel="cancel"
                         :loading="btnIsLoading"
                         v-if="!disabled">
      </mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  staff_relation_add,
  staff_relation_edit,
  staff_relation_detail,
  correlation_delete,
} from '@/service/api/staffRelation.js'
import { getBusinessList } from '@/service/api/prompt.js'
import {
  required,
  maxLength,
  between,
  email,
  url,
} from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skeletonloading: true,
      dropDownList: [],
      list: {
        // correlation_status: 1
      },
      btnIsLoading: false,
      viewList: {},
    }
  },
  computed: {
    complete_probations () {
      //员工转正参照 
      if (this.$store.state.uuid) {
        return {
          prompt_name: 'complete_probation-update',
          org_level_uuid: this.$store.state.currentCompany,
          staff_uuid: this.list.staff_uuid
        }
      } else {
        return {
          prompt_name: 'complete_probations',
          org_level_uuid: this.$store.state.currentCompany,
        }
      }
    },
  },
  async created () {

  },
  watch: {},
  async mounted () {
    this.national('mrbase_sys_correlation')
    if (this.$store.state.uuid) {
      await this.getDetail()
    }
    else {
    }
  },

  methods: {
    async getDetail () {
      this.skeletonloading = true
      const res = await staff_relation_detail({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = res.data
      } else {
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      if (this.$store.state.uuid) {
        staff_relation_edit(this.$deletefield(null, this.list)).then(
          async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t('message_The_operation_was_successful'),
              })
              await this.getDetail()
              this.$emit('changeReadonly')
            }
          }
        )
      }
      else {
        staff_relation_add({
          ...this.list,
          org_level_uuid: this.$store.state.currentCompany,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            this.$router.push({ name: 'staffRelation' })
          }
        })
      }
    },
    async cancel () {
      if (this.$store.state.uuid) {
        await this.getDetail()
        this.$emit('changeReadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
        })
          .then((res) => {
            this.$router.push({
              name: 'staffRelation',
            })
          })
          .catch((err) => { })
      }

    },
  },
  validations: {
    list: {
      correlation_name: {
        required,
      },
      correlation_code: {
        required,
      },
      remarks: {
        required,
      },
    },
  },
}
</script>

<style scoped></style>
